import { pushData, formatSectionData } from '@ynap/live-chat'
import getConfig from 'next/config'

export default function pushDataToLiveChat(data, locale) {
  const shouldPushToLiveChat = !!(data && locale)

  if (shouldPushToLiveChat) {
    const formattedData = formatSectionData(data)
    const { publicRuntimeConfig } = getConfig()

    if (formattedData?.length) {
      const additionalSections = []
      const liveChatCountry = locale.country === 'US' ? locale.country : undefined
      liveChatCountry && additionalSections.push(liveChatCountry)
      pushData({ sectionData: [publicRuntimeConfig.liveChatBrand, locale.language, ...formattedData], additionalSections })
    }
  }
}
